import fetch from './fetch'

export default {
  getPrograms (payload) {
    let request = fetch({
      url: `/program`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getProgram (payload) {
    const id = payload.id
    let request = fetch({
      url: `/program/` + id,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createProgram (payload) {
    let request = fetch({
      url: `/program`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  updateProgram (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/program/` + id,
      method: 'patch',
      data: data
    })
    return request.call()
  },
  deleteProgram (payload) {
    const id = payload.id
    let request = fetch({
      url: `/program/` + id,
      method: 'delete'
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/program.js